<script setup lang="ts">
const props = defineProps({
  width: {
    type: String,
    default: '100%',
  },
  height: {
    type: String,
    default: '100%',
  },
  customClass: {
    type: String,
    default: '',
  },
})
</script>
<template>
  <div
    class="skeleton"
    :class="customClass"
    :style="{ width: props.width, height: props.height }"
  />
</template>
<style lang="scss" scoped>
.skeleton {
  background-color: #2E2F31;
  background-image: linear-gradient(90deg, #2f3032, #2f2f31, #2f3032);
  background-size: 40px 100%;
  background-repeat: no-repeat;
  background-position: left -40px top 0;
  animation: shine 1s ease infinite;
  @include media-query(max, $size-container) {
    margin-bottom: 5px;
  }
}

@keyframes shine {
  to {
    background-position: right -40px top 0;
  }
}
</style>
